import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IconToastWarning } from '../../../../../../../../assets/toast-icons/icon-toast-warning';
import { UserPermissionType } from '../../../../../../../../data-access/gql-types/graphql';
import { useUserPermissions } from '../../../../../../../../hooks/user/use-user-permissions';
import { ROUTES } from '../../../../../../../../routes/routes';
import './index.scss';

type EmptyPricesProps = {
  channelId: string;
};

export const EmptyPrices: React.FC<EmptyPricesProps> = ({ channelId }) => {
  const { t: t } = useTranslation('channel-details');
  const { permissions } = useUserPermissions();

  if (permissions[UserPermissionType.ChannelConfiguration]) {
    return (
      <Link to={ROUTES.TariffConfiguration(channelId)}>
        <div className="empty-prices link">
          <IconToastWarning /> <span>{t('pricesEmpty')}</span>
        </div>
      </Link>
    );
  }

  return (
    <div className="empty-prices">
      <IconToastWarning /> <span>{t('pricesEmpty')}</span>
    </div>
  );
};
